import { z } from 'zod';

const TakeProfitLevelInputSchema = z.object({
  threshold: z.number(),
  positionPercent: z.number()
});

export const ScaleInConfigInputSchema = z.object({
  enabled: z.boolean().default(true),
  addSize: z.preprocess(
    (value) => (value === '' ? undefined : value),
    z.number().positive().optional()
  ),
  minPriceStepFromLastSignalPercent: z.preprocess(
    (value) => (value === '' ? undefined : value),
    z.number().nonnegative().optional()
  ),
  onlyInProfit: z.boolean().default(true)
});

export const PositionManagementConfigInputSchema = z.object({
  positionSize: z.number(),
  leverage: z.number(),
  commissionPercent: z.number().optional(),
  stopLoss: z.boolean().optional(),
  trailingStop: z.boolean().optional(),
  trailingStopPercent: z.preprocess(
    (value) => (value === '' ? undefined : value),
    z.number().positive().optional()
  ),
  stopLossPercent: z.number().optional(),
  scalping: z.boolean().optional(),
  takeProfitLevels: z.array(TakeProfitLevelInputSchema).optional(),
  scaleIn: ScaleInConfigInputSchema.optional()
});

export type TakeProfitLevelInput = z.infer<typeof TakeProfitLevelInputSchema>;
export type ScaleInConfigInput = z.infer<typeof ScaleInConfigInputSchema>;
export type PositionManagementConfigInput = z.infer<
  typeof PositionManagementConfigInputSchema
>;
